// extracted by mini-css-extract-plugin
export var dropdownIcon = "_m3-6";
export var imgContainer = "_m3-3";
export var menuIcon = "_m3-5";
export var pillWrapper = "_m3-2";
export var pillsContainer = "_m3-1";
export var subscriptionCard = "_m3-0";
export var subscriptionLogo = "_m3-4";